export const config = {
  /**
   * ClientID to authorize users during subscription provisioning process
   */
  LANDING_PAGE_CLIENT_ID: process.env.LANDING_PAGE_CLIENT_ID ?? '',
  /**
   * Permissions to be requested during authoriztion for provisioning process
   */
  LANDING_PAGE_SCOPE: (process.env.LANDING_PAGE_SCOPE ?? '').split(' '),
  /**
   * Base url of landing page (see webpack.config.js > output > publicPath)
   * defines url for redirect after login
   */
  LANDING_PAGE_REDIRECT_URL: process.env.LANDING_PAGE_REDIRECT_URL ?? '',
  /**
   * ClientID to be used by Outlook Add-in to authorize users during SSO
   */
  ADD_IN_CLIENT_ID: process.env.ADD_IN_CLIENT_ID ?? '',
  /**
   * Permissions to be used by Add-in during usage
   */
  ADD_IN_SCOPE: process.env.ADD_IN_SCOPE ?? '',
  /**
   * where to redirect after admin consent for add-in permissions
   */
  ADD_IN_CONSENT_REDIRECT_URL: process.env.ADD_IN_CONSENT_REDIRECT_URL ?? ''
}